<template>
    <div>
        <v-dialog v-model="value" scrollable persistent max-width="500px" transition="dialog-transition">
            <v-card>
                <v-card-text>
                   <h2>Get Connected</h2>
                    <p>GT Connect is our FREE Quote and Information service to help you obtain what you are looking for in a quick and efficient manner from people you can trust. You can rest assured your information is kept confidential. Once you choose your category, you will be provided a list of people we know and trust can deliver the services you are looking for. Make as many selections as you wish and simply click submit.
                    It's That Easy. Get Started and Get Connected Today! After All... It's FREE!</p>
                    <video style="width:100%" controls=""> 
                        <source src="http://www.globaltrademag.com/GTConnect/assets/images/video.mp4" type="video/mp4">
                    </video>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="$emit('input', false)" color="primary">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props:['value']
}
</script>